// Instrument Sans / Geist / Geist Mono — self-hosted woff2 из npm-пакетов,
// без сторонних CDN (DESIGN_SYSTEM §3). Токены подключает app/styles/global.css.
//
// Geist остаётся подключённым и после смены основного шрифта: в Instrument Sans
// нет кириллицы (subsets latin, latin-ext), и локаль `ru` набирается Geist по
// поглифному фолбэку из --font-sans. Убрать пакет — значит отдать русский
// интерфейс системному шрифту.
import '@fontsource-variable/instrument-sans';
import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';
import './app/styles/global.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root is missing in index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
